import _ from 'lodash';

import './resources.scss';

/* @ngInject */
export default function resourcesController(ResourcesFactory, $stateParams, $state, $window, $analytics, HPConfig, $http, mapBoxGL, $scope, UserData, PermissionsFactory) {
    const vm = this;
    let glMap = null;

    vm.resourcePages = [];
    vm.resourceVideos = [];
    vm.currentPage = {};
    vm.pageUrl = '';
    vm.sproutLoudData = {};
    vm.mapType = 'company';
    vm.mapLoading = true;
    vm.user;
    vm.isSolicitor = PermissionsFactory.hasPermission('IsSolicitor');
    vm.isAdvertiser = PermissionsFactory.hasPermission('IsAdvertiser');

    init();

    /*= =======================================
	 =            Public Functions            =
	 ======================================== */

    vm.trackClick = function (eventName) {
        const clickEvent = {
            title: 'Resource Clicked',
            action: '',
        };
        switch (eventName) {
            case 'openLetter':
                clickEvent.title = 'User clicked "An open letter to California contractors"';
                clickEvent.action = 'Letter to CO click';
                break;
            case 'watchTutorial':
                clickEvent.title = 'User clicked "A tutorial on the new HERO application"';
                clickEvent.action = 'App tutorial click';
                break;
            case 'seeSteps':
                clickEvent.title = 'User clicked "How to Apply helper"';
                clickEvent.action = 'How to apply click';
                break;
            case 'takeLook':
                clickEvent.title = 'User clicked "The HAC Walkthrough"';
                clickEvent.action = 'HAC Walkthrough click';
                break;
            case 'getGuide':
                clickEvent.title = 'User clicked "Income Verification: The Guide"';
                clickEvent.action = 'Income verification guide click';
                break;
            case 'getOverview':
                clickEvent.title = 'User clicked "Get a high-level overview"';
                clickEvent.action = 'Overview click';
                break;
            case 'getFullStory':
                clickEvent.title = 'User clicked "Get the full story"';
                clickEvent.action = 'Full story click';
                break;
            default:
                break;
        }
        $analytics.eventTrack(clickEvent.title, {
            action: clickEvent.action,
            category: 'PACE Resources',
            label: vm.user.UserName,
        });
    };

    vm.switchPage = function (page) {
        vm.currentPage = page;
        buildPageUrl();
        $state.go('resources', {
            resourceName: page.pageName,
        });
    };

    vm.sproutLoudHandShake = function () {
        $analytics.eventTrack('SSO Initiate', {
            category: 'SproutLoud',
        });
        const newWindow = $window.open('');
        ResourcesFactory.sproutLoudHandShake().then((response) => {
            if (response.data.Errors === undefined) {
                const doc = newWindow.document;
                const form = doc.createElement('form');
                form.setAttribute('method', 'POST');
                form.setAttribute('action', response.data.Data.SeamlessLoginURL);
                const hiddenField = doc.createElement('input');
                hiddenField.setAttribute('type', 'hidden');
                hiddenField.setAttribute('name', 'login_data');
                hiddenField.value = response.data.Data.EncrypedDataXML;
                form.appendChild(hiddenField);
                doc.body.appendChild(form);

                form.submit();
            } else {
                $analytics.eventTrack('SSO Failed', {
                    category: 'SproutLoud',
                    label: JSON.stringify(response.data.Errors),
                });
                newWindow.location = response.data.Data.SeamlessLoginURL;
            }
        }, (response) => {
            $analytics.eventTrack('SSO Failed', {
                category: 'SproutLoud',
                label: JSON.stringify(response.data.Errors),
            });
            newWindow.location = 'http://app.sproutloud.com';
        });
    };

    vm.changeMapType = function () {
        vm.mapLoading = true;
        initializeHEROMap();
    };
    /* -----  End of Public Functions  ------*/

    /*= =======================================
	 =            Private Functions            =
	 ======================================== */
    function init() {
        if (vm.isAdvertiser && $stateParams.resourceName === 'videos') { // Advertiser doesn't have Videos page access, but that's the default route - so have to redirect.
            $window.location.href = '/resources/participant';
        }

        getResourcePages();
        setInitialPage();
        buildPageUrl();

        if ($stateParams.resourceName === 'videos') {
            getResourceVideos();
        }

        if ($stateParams.resourceName === 'map') {
            // Need to defer to ensure that the map DOM element has already been loaded
            _.defer(() => {
                initializeHEROMap();
            });
        }
        console.log('should be getting userData');
        UserData.getUserData().then((result) => {
            vm.user = result;
        });
    }

    function getResourcePages() {
        vm.resourcePages = ResourcesFactory.getResourcePages();
    }

    function getResourceVideos() {
        vm.resourceVideos = ResourcesFactory.getResourceVideos();
    }

    function initializeHEROMap() {
        if (vm.mapType === 'company') {
            $http.get(`${HPConfig.heroProApi}Contractor/GeoJSON`, {
                cache: true,
            }).then((response) => {
                loadHEROMap({
                    style: 'mapbox://styles/mapbox/basic-v8',
                    data: response.data,
                });
            });
        } else if (vm.mapType === 'all') {
            loadHEROMap({
                style: 'mapbox://styles/jrichmond/ciusglhby004h2ipho7pzjkkh',
            });
        }
    }

    function loadHEROMap(options) {
        // https://www.mapbox.com/mapbox-gl-js/api/
        if (glMap !== null) {
            glMap.remove();
        }

        mapBoxGL.accessToken = HPConfig.mapBoxAuthKey;

        glMap = new mapBoxGL.Map({
            attributionControl: false,
            container: 'resourcesHeroMap',
            style: options.style,
            maxBounds: new mapBoxGL.LngLatBounds(new mapBoxGL.LngLat(-127.881285, 23.827067), new mapBoxGL.LngLat(-66.565297, 49.976707)),
            maxZoom: 15,
            zoom: 5,
            center: [-119.882153, 35.929159],
        });

        glMap.addControl(new mapBoxGL.Navigation({
            position: 'top-left',
        }));
        glMap.addControl(new mapBoxGL.Geolocate({
            position: 'top-left',
        }));

        if (options.data !== undefined && options.data.features !== null) {
            glMap.on('style.load', () => {
                glMap.addSource('markers', new mapBoxGL.GeoJSONSource({
                    data: options.data,
                }));
                glMap.addLayer({
                    id: 'geojsondata',
                    source: 'markers',
                    type: 'circle',
                    paint: {
                        'circle-color': '#ED1F34',
                        'circle-radius': 5,
                        'circle-opacity': 1,
                    },
                    // type: "symbol",
                    // layout: {
                    //      "icon-image": "circle-11"
                    //  },
                    //  paint: {
                    // 	"icon-opacity": 0.7,
                    // 	// "icon-color": "#ED1F34", //doesn't seem to be supported
                    // }
                });
            });
        }

        glMap.on('load', () => {
            vm.mapLoading = false;
            $scope.$digest();
            _.defer(() => {
                glMap.resize();
            });
        });
    }

    function setInitialPage() {
        const pages = _.filter(vm.resourcePages, page => page.pageName === $stateParams.resourceName);
        if (pages !== undefined && pages !== null) {
            vm.currentPage = pages[0];
        } else {
            vm.currentPage = vm.resourcePages[0];
        }
    }

    function buildPageUrl() {
        if (vm.currentPage && vm.currentPage.pageName) {
            vm.pageUrl = `app/resources/resources_${vm.currentPage.pageName}.html`;
        }
    }
    /* -----  End of Private Functions  ------*/
}



// WEBPACK FOOTER //
// ./src/app/resources/resourcesController.js